export enum SynopticType {
  SCHEMA = 'schema',
  COMPONENT = 'component',
}
